module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight--dark-1310d7361e5256e763842cc14efdad99.png";